import config from 'config';
import React from 'react';
import PropTypes from 'prop-types';
import BasicCallout from '@mulesoft/exchange-ui-components/lib/components/BasicCallout';
import Page from '~/components/Page/Page';
import { getPredefinedPageName } from '~/utils/page';
import styles from './TermsPage.css';

export default class TermsPage extends React.PureComponent {
  static propTypes = {
    page: PropTypes.object,
    isContributor: PropTypes.bool,
    isPortalLoading: PropTypes.bool,
    isPublicPortal: PropTypes.bool
  };

  render() {
    const { page, isContributor, isPortalLoading, isPublicPortal, ...props } =
      this.props;

    const defaultTermsText = '<span></span>';

    const resolvedPage = {
      ...page,
      path: config.termsPageName,
      name: getPredefinedPageName({ path: config.termsPageName }),
      html: page?.html || defaultTermsText
    };

    return (
      <React.Fragment>
        <Page
          {...props}
          page={resolvedPage}
          isContentLoading={isPortalLoading}
          hasTitle
        />
        <BasicCallout
          className={styles.callout}
          testId="terms-page-auto-generated-callout"
          type="info"
          title="This Page was generated because one or more group instances have underlying API with terms and conditions."
          subtitle="You can add the group's terms and conditions page by editing the portal."
          display-if={
            !isPublicPortal &&
            !isPortalLoading &&
            isContributor &&
            (!page || !page.html)
          }
        />
      </React.Fragment>
    );
  }
}
